import { render, staticRenderFns } from "./IconCartOk.vue?vue&type=template&id=2a7d1542&"
import script from "./IconCartOk.vue?vue&type=script&lang=ts&"
export * from "./IconCartOk.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports